import React, { ChangeEvent } from "react";

type DateFieldProps = {
  pattern?: string;
  value: string | undefined;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  type?: string;
}

type DateFieldBoxProps = {
  label: React.ReactNode;
  pattern?: string;
  value: string | undefined;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  type?: string;
}

export const DateField: React.FC<DateFieldProps> = ({pattern="", value, onChange, type="date"}) => (
    <div className="contact-box__ct">
      <div className="date-calendar">
        <input type={type} className="input input--pw" pattern={pattern} value={value} onChange={onChange} />
      </div>
    </div>
);

export const DateFieldBox: React.FC<DateFieldBoxProps> = ({ label, pattern="", value, onChange, required =false, type="date"}) => (
  <div className="contact-box__item">
    <label className="contact-box__ttl">
      <span>{label}</span>
      { required && <small>必須</small> }
    </label>
    <DateField pattern={pattern} value={value} onChange={onChange} type={type} />
  </div>
);